<template>
    <div class="convention-push">
        <convention-push-header :pushes="pushes" :convention="convention" :user="user">
        </convention-push-header>
        <div class="convention-push-list">
            <sep name="L" />
            <push-item v-for="push in pushes" :key="push.id" :push="push"></push-item>
        </div>
    </div>
</template>

<script>
import ConventionPushHeader from "src/components/convention/push/ConventionPushHeader.vue";
import { Services } from "src/services/Services";
import PushItem from "../../push/PushItem";
export default {
    components: { ConventionPushHeader, PushItem },
    props: ["convention", "user"],
    data() {
        return {
            pushes: [],
            loading: false,
        };
    },
    async mounted() {
        await this.fetchPushes();
    },
    methods: {
        async fetchPushes() {
            this.loading = true;
            try {
                this.pushes = await Services.api.push.getAllByConventionId(
                    this.convention.conventionId
                );
            } catch (e) {
                console.error(e);
                this.pushes = [];
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        async convention() {
            await this.fetchPushes();
        },
    },
};
</script>

<style scoped lang="sass">

.convention-push
    padding: $grid-gutter * 1.5 0
</style>
